export class HistoryDataModel {
    constructor(error, isUnbind, values) {
        this.error = error;
        this.isUnbind = isUnbind;
        this.values = values;
    }
}
